import { Ref, forwardRef } from 'react'

import { Box, useClassNames } from '@factorialco/deprecated-design-system'
import { TimePlanningBalance, TimePlanningBalancesByPeriod } from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import { type ContractVersions } from 'modules/contracts/store/collections/contractVersions'
import WrapperCell from 'modules/shift_management/components/ShiftManagement/Content/Body/DataTable/Cells/WrapperCell'
import * as stylesRefs from 'modules/shift_management/components/ShiftManagement/Content/Body/DataTable/index.vanilla.css'
import { useSchedule } from 'modules/shift_management/hooks/useSchedule'
import type { ShiftsRow } from 'modules/shift_management/lib/types'

import { type ColumnsType, gridTemplateColumns } from '../utils/buildColumns'
import { FirstCell } from './FirstCell'
import ShiftsRowsPerView from './ShiftsRowsPerView'

interface RowProps {
  shiftsRow: ShiftsRow
  columns: ColumnsType
  contractVersions: ContractVersions
  balances?: TimePlanningBalance
  periodBalances?: TimePlanningBalancesByPeriod[]
}

const Row = (
  { shiftsRow, columns, contractVersions, balances, periodBalances }: RowProps,
  ref: Ref<HTMLDivElement>
) => {
  const [{ view }] = useSchedule()
  const cx = useClassNames(stylesRefs)

  return (
    <Box
      ref={ref}
      className={cx('grid')}
      style={{
        ...gridTemplateColumns('s240', view, 'content', 0),
      }}
    >
      <WrapperCell sticky minWidth="s240">
        <FirstCell
          view={view}
          shiftsRow={shiftsRow}
          contractVersions={contractVersions}
          balances={balances}
          periodBalances={periodBalances}
        />
      </WrapperCell>
      <ShiftsRowsPerView
        shiftsRow={shiftsRow}
        columns={columns}
        contractVersions={contractVersions}
      />
    </Box>
  )
}

export default observer(forwardRef(Row))
